import { oc } from "@orpc/contract";
import { z } from "zod";

const rabbitmqClientStatusSchema = z.object({
  /** "v2" = pooled/dedicated-channel client. Use enum (not z.literal) so OpenAPI keeps type: string. */
  name: z.enum(["v2"]),
  connected: z.boolean(),
  everConnected: z.boolean(),
  lastConnectedAt: z.string().nullable(),
});

const rabbitmqWatchdogStatusSchema = z.object({
  running: z.boolean(),
  targets: z.array(
    z.object({
      name: z.string(),
      everConnected: z.boolean(),
      connected: z.boolean(),
      consecutiveMisses: z.number(),
      downSince: z.string().nullable(),
      lastAlertAt: z.string().nullable(),
    }),
  ),
});

const rabbitmqHealthStatusSchema = z.object({
  configured: z.boolean(),
  /** Active broker probe: open + close a channel on the shared connection */
  healthy: z.boolean(),
  probeLatencyMs: z.number().nullable(),
  clients: z.array(rabbitmqClientStatusSchema),
  channelStats: z
    .object({
      totalChannels: z.number(),
      availablePooledChannels: z.number(),
      inUsePooledChannels: z.number(),
      dedicatedChannels: z.array(
        z.object({ id: z.string(), createdAt: z.string() }),
      ),
    })
    .nullable(),
  watchdog: rabbitmqWatchdogStatusSchema.nullable(),
  checkedAt: z.string(),
});

export const rabbitmqHealthContracts = {
  getStatus: oc.input(z.void()).output(rabbitmqHealthStatusSchema).route({
    method: "POST",
    summary: "Admin-only RabbitMQ broker health and connection status",
  }),
};

export type RabbitmqHealthStatus = z.infer<typeof rabbitmqHealthStatusSchema>;
